import React from 'react'
import { Card, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons'
import useScreenSize from '../hooks/useScreenSize'
import useQRCodeModal from '../hooks/useQRCodeModal'
import QRCodeModal from './QRCodeModal'
import { APP_STORE_URLS, CARD_GRADIENTS } from '../utils/constants'
import { handleButtonMouseEnter, handleButtonMouseLeave } from '../utils/helpers'

const { Title, Paragraph } = Typography

const DownloadAppCard = () => {
  const isMobile = useScreenSize()
  const { modalVisible, qrCodeValue, showModal, handleCancel } = useQRCodeModal()

  const createShinyButton = (type, onClick, icon, text = '') => {
    const isCircular = type === 'circular'
    const baseStyle = {
      width: isCircular ? '48px' : 'auto',
      height: isCircular ? '48px' : 'auto',
      padding: isCircular ? '0' : '12px 24px',
      borderRadius: isCircular ? '50%' : '8px',
      background: `
        linear-gradient(145deg, #2a2a2a 0%, #000000 50%, #1a1a1a 100%),
        linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 50%, transparent 100%)
      `,
      boxShadow: `
        inset 0 1px 0 rgba(255,255,255,0.2),
        inset 0 -1px 0 rgba(0,0,0,0.5),
        0 4px 8px rgba(0,0,0,0.3),
        0 0 0 1px rgba(255,255,255,0.1)
      `,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      fontWeight: isCircular ? 'normal' : '600',
      fontSize: isCircular ? 'inherit' : '14px',
      gap: isCircular ? '0' : '8px',
      color: 'white',
      textShadow: isCircular ? 'none' : '0 1px 2px rgba(0,0,0,0.5)'
    }

    return (
      <div
        style={baseStyle}
        onClick={onClick}
        onMouseEnter={(e) => handleButtonMouseEnter(e, type)}
        onMouseLeave={(e) => handleButtonMouseLeave(e, type)}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{
            color: 'white',
            fontSize: isCircular ? '20px' : 'inherit',
            filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))'
          }}
        />
        {text && text}
      </div>
    )
  }

  return (
    <>
      <Card
        bordered={false}
        style={{
          background: CARD_GRADIENTS.lightBlue,
          color: '#1f1f1f',
          borderRadius: '12px',
          textAlign: 'center',
          padding: '24px',
          height: '100%'
        }}
      >
        <Title level={3} style={{ color: '#1f1f1f', margin: '0 0 16px 0' }}>
          Download Our Mobile App
        </Title>
        <div style={{ marginBottom: '20px', color: '#595959', lineHeight: '1.6', textAlign: 'left' }}>
          <Paragraph style={{ marginBottom: '12px', color: '#595959', fontSize: '14px', textAlign: 'center' }}>
            Take your healthcare on the go with convenient features:
          </Paragraph>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#595959', fontSize: '14px', lineHeight: '1.6' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Schedule appointments</strong> - Book consultations anytime, anywhere
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Fitness guide</strong> - Personalised exercise plans and tracking
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>AI meal tracking</strong> - Smart nutrition monitoring and recommendations
            </li>
            <li style={{ marginBottom: '0px' }}>
              <strong>Health monitoring</strong> - Track vitals and sync with your care team
            </li>
          </ul>
        </div>
        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center', gap: '16px' }}>
          {isMobile ? (
            // Mobile - Circular buttons
            <>
              {createShinyButton('circular', () => showModal(APP_STORE_URLS.ios), faApple)}
              {createShinyButton('circular', () => showModal(APP_STORE_URLS.android), faGooglePlay)}
            </>
          ) : (
            // Desktop/Tablet - Full buttons
            <>
              {createShinyButton('rectangular', () => showModal(APP_STORE_URLS.ios), faApple, 'App Store')}
              {createShinyButton('rectangular', () => showModal(APP_STORE_URLS.android), faGooglePlay, 'Google Play')}
            </>
          )}
        </div>
      </Card>
      <QRCodeModal visible={modalVisible} onCancel={handleCancel} qrCodeValue={qrCodeValue} />
    </>
  )
}

export default DownloadAppCard
